export default Object.freeze({
  RECHAZADA: 0,
  REGISTRADO: 10,
  AUTORIZADA: 20,
  PREVENTA: 25,
  CREDITO: 30,
  LIQUIDADO: 40
})
